module.exports = __webpack_public_path__ + "dadbe352409bcfba2fc4ce91868f61d9.png";